import { IonSegment, IonSegmentButton, IonLabel } from "@ionic/react";
import { useDispatch, useSelector } from "react-redux";
import { setSegmentSelected } from "../../../store/locationShow";
import { selectSegmentSelected } from "../../../store/locationShow/selectors/selectSegmentSelected";
import { HistorySection } from "./HistorySection";
import { InfoSection } from "./InfoSection";
import { UserRolesSection } from "./UserRolesSection";

export const SegmentsSection = () => {
  const dispatch = useDispatch();
  const segmentSelected = useSelector(selectSegmentSelected);
  return (
    <>
      <IonSegment
        onIonChange={(e) => {
          dispatch(setSegmentSelected(e.detail.value || ""));
        }}
        value={segmentSelected}
        color="primary"
        style={{ maxWidth: "500px" }}
      >
        <IonSegmentButton value="info">
          <IonLabel>General</IonLabel>
        </IonSegmentButton>
        <IonSegmentButton value="roles">
          <IonLabel>Usuarios</IonLabel>
        </IonSegmentButton>
        <IonSegmentButton value="history">
          <IonLabel>Historial</IonLabel>
        </IonSegmentButton>
      </IonSegment>

      <section style={{ maxWidth: "1000px" }} className="ion-margin-top">
        {segmentSelected === "info" && <InfoSection />}
        {segmentSelected === "roles" && <UserRolesSection />}
        {segmentSelected === "history" && <HistorySection />}
      </section>
    </>
  );
};
